import { withTranslation } from 'react-i18next'

export const NAMESPACE = 'WEBSITE'
export const withWebTranslation = withTranslation(NAMESPACE)
